import React, {useEffect, useState} from 'react';
import TargetHeader from "./components/TargetHeader/TargetHeader";
import cl from './Target.module.css';
import TargetList from "./components/TargetList/TargetList";
import {v4 as uuidv4} from 'uuid';
import TargetDialog from "./components/TargetDialog/TargetDialog";
import {checkIfSimilarTargetExists, getTargetLabel} from "./utils";
import {toast} from "react-toastify";

const initialValue = {
    id: null,
    dbId: 0,
    buildingType: null,
    label: '',
    section: {
        key: null,
        value: null
    },
    homeOwner: {
        key: null,
        value: null
    },
    subSection: {
        key: null,
        value: null
    },
    street: {
        key: null,
        value: null
    },
    building: {
        key: null,
        value: null
    },
    entrance: {
        key: null,
        value: null
    },
    apartment: {
        key: null,
        value: null
    }
};

const Target = ({targets, disabled, change}) => {
    const [showDialog, setShowDialog] = useState(false);
    const [dialogItem, setDialogItem] = useState(null);
    const [items, setItems] = useState([]);

    useEffect(() => {
        // debugger;
        //   if (targets && targets.length > 0) {
        setItems(targets == null ? [] : targets);
        // }
    }, [targets]);

    const removeTarget = (id) => {
        if (!disabled) {
            if (change) {
                change([...items.filter(item => item.id !== id)]);
            } else {
                setItems(prev => {
                    let data = [...prev.filter(item => item.id !== id)];

                    if (change) {
                        change(data);
                    }

                    return data;
                });
            }
        }
    }

    const editTarget = (id) => {
        if (!disabled) {
            let item = items.find(item => item.id === id);

            setDialogItem(item ? item : {
                ...initialValue,
                id: uuidv4()
            });

            setShowDialog(prev => !prev);
        }
    }

    const closeDialog = () => {
        if (showDialog) {
            setDialogItem(null);

            setShowDialog(prev => !prev);
        }
    }

    const saveTarget = (ev) => {
        if (ev) {

            if (checkIfSimilarTargetExists(items, ev)) {
                toast.error('Item with similar data already exists');
            } else {

                if (ev.homeOwner !== null && ev.homeOwner.length > 0 /*&& target.homeOwner.key !== null && target.homeOwner.value !== null*/) {
                    let array = items;
                    ev.homeOwner.forEach(evKey => {
                        const item = {
                            ...ev,
                            homeOwner: {key: evKey.id, value: evKey.label},
                            subSection: {key: null, value: null},
                            section: {key: null, value: null},
                            street: {key: null, value: null},
                            building: {key: null, value: null},
                            entrance: {key: null, value: null},
                            apartment: {key: null, value: null},
                            label: evKey.label,
                            id: uuidv4()
                        };

                        array = array.find(item => item.id === ev.id)
                            ? [item, ...array.filter(item => item.id !== ev.id)]
                            : [item, ...array]

                    })

                    if (change) {
                        change(array);
                    }
                    setItems(array);

                } else {
                    if (ev.subSection !== null && ev.subSection.length > 0 /*&& target.homeOwner.key !== null && target.homeOwner.value !== null*/) {
                        let array = items;
                        ev.subSection.forEach(evKey => {
                            const item = {
                                ...ev,
                                subSection: {key: evKey.id, value: evKey.label},
                                homeOwner: {key: null, value: null},
                                section: {key: null, value: null},
                                street: {key: null, value: null},
                                building: {key: null, value: null},
                                entrance: {key: null, value: null},
                                apartment: {key: null, value: null},
                                label: evKey.label,
                                id: uuidv4()
                            };

                            array = array.find(item => item.id === ev.id)
                                ? [item, ...array.filter(item => item.id !== ev.id)]
                                : [item, ...array]

                        })

                        if (change) {
                            change(array);
                        }
                        setItems(array);

                    } else {
                        if (ev.section !== null && ev.section.length > 0) {
                            let array = items;
                            if (ev.street !== null && ev.street.length > 0) {
                                if (ev.building !== null && ev.building.length > 0) {

                                    if (ev.building.length === 1) {

                                        if (ev.entrance !== null && ev.entrance.length > 0) {

                                            ev.entrance.forEach(evKey => {
                                                let item = {
                                                    ...ev,
                                                    section: {key: ev.section[0].id, value: ev.section[0].label},
                                                    street: {key: ev.street[0].id, value: ev.street[0].label},
                                                    building: {key: ev.building[0].id, value: ev.building[0].label},
                                                    entrance: {key: evKey.id, value: evKey.label},
                                                    apartment: {key: null, value: null},
                                                    id: uuidv4()
                                                };
                                                item = {
                                                    ...item,
                                                    label: getTargetLabel(item),
                                                };
                                                array = [item, ...array]

                                            })
                                        }
                                        if (ev.apartment !== null && ev.apartment.length > 0) {

                                            ev.apartment.forEach(evKey => {
                                                let item = {
                                                    ...ev,
                                                    section: {key: ev.section[0].id, value: ev.section[0].label},
                                                    street: {key: ev.street[0].id, value: ev.street[0].label},
                                                    building: {key: ev.building[0].id, value: ev.building[0].label},
                                                    entrance: {key: null, value: null},
                                                    apartment: {key: evKey.id, value: evKey.label},
                                                    id: uuidv4()
                                                };
                                                item = {
                                                    ...item,
                                                    label: getTargetLabel(item),
                                                };


                                                array = [item, ...array]

                                            })
                                        }
                                        if ((ev.apartment === null || ev.apartment.length === 0) && (ev.entrance === null || ev.entrance.length === 0)) {

                                            let item = {
                                                ...ev,
                                                section: {key: ev.section[0].id, value: ev.section[0].label},
                                                street: {key: ev.street[0].id, value: ev.street[0].label},
                                                building: {key: ev.building[0].id, value: ev.building[0].label},
                                                entrance: {key: null, value: null},
                                                apartment: {key: null, value: null},
                                                id: uuidv4()
                                            };
                                            item = {
                                                ...item,
                                                label: getTargetLabel(item),
                                            };
                                            array = [item, ...array]


                                        }
                                    }
                                    else {

                                        ev.building.forEach(evKey => {
                                            let item = {
                                                ...ev,
                                                section: {key: ev.section[0].id, value: ev.section[0].label},
                                                street: {key: ev.street[0].id, value: ev.street[0].label},
                                                building: {key: evKey.id, value: evKey.label},
                                                entrance: {key: null, value: null},
                                                apartment: {key: null, value: null},
                                                id: uuidv4()
                                            };
                                            item = {
                                                ...item,
                                                label: getTargetLabel(item),
                                            };
                                            array = [item, ...array]

                                        })


                                    }

                                    if (change) {
                                        change(array);
                                    }

                                    setItems(array);
                                }
                                else {
                                    ev.street.forEach(evKey => {
                                        let item = {
                                            ...ev,
                                            section: {key: ev.section[0].id, value: ev.section[0].label},
                                            street: {key: evKey.id, value: evKey.label},
                                            building: {key: null, value: null},
                                            entrance: {key: null, value: null},
                                            apartment: {key: null, value: null},
                                            label: evKey.label,
                                            id: uuidv4()
                                        };
                                        item = {
                                            ...item,
                                            label: getTargetLabel(item),
                                        };
                                        array = array.find(item => item.id === ev.id)
                                            ? [item, ...array.filter(item => item.id !== ev.id)]
                                            : [item, ...array]

                                    })

                                    if (change) {
                                        change(array);
                                    }
                                    setItems(array);
                                }
                            } else {

                                ev.section.forEach(evKey => {
                                    const item = {
                                        ...ev,
                                        section: {key: evKey.id, value: evKey.label},
                                        street: {key: null, value: null},
                                        building: {key: null, value: null},
                                        entrance: {key: null, value: null},
                                        apartment: {key: null, value: null},
                                        label: evKey.label,
                                        id: uuidv4()
                                    };

                                    array = array.find(item => item.id === ev.id)
                                        ? [item, ...array.filter(item => item.id !== ev.id)]
                                        : [item, ...array]

                                })

                                if (change) {
                                    change(array);
                                }
                                setItems(array);
                            }
                        }
                    }
                }

            }

            setShowDialog(prev => !prev);
        }
    }

    return (
        <div className={cl.targetContainer}>
            <TargetHeader onAddButtonClick={editTarget}/>
            <TargetList items={items}
                        onRemoveButtonClick={removeTarget}
                        onEditButtonClick={editTarget}/>
            {dialogItem &&
                <TargetDialog open={showDialog}
                              close={closeDialog}
                              save={saveTarget}
                              onOverlayClick={closeDialog}
                              target={dialogItem}/>
            }
        </div>
    );
};

export default Target;
